<template>
	<article>
		<section class="header-bg">
			<div class="all-header">
				<div class="layui-fluid container-1200">
					<div class="logo_sdf" style="display: flex;align-items: center;">
						<div class="logo_image" @click="goToHome">
							<img :src="require('@/assets/images/logo.png')" />
						</div>
						<div id="warp-menu" style="margin:25px 0px 0px 295px;">
							<Menu></Menu>
						</div>
						<div class="menu_btns" @click="() => drawer = true">
							<img :src="daohangImageUrl" alt="" class="daohang_image">
						</div>
					</div>
				</div>
			</div>

			<div class="menu-bottom-text container-1200">
				<p>Welcome to <br />Contrimetric</p>
				<el-button type="primary" class="apply_btn" @click="goToRequestDemo">Request a
					Demo</el-button>
			</div>
		</section>

		<el-drawer title="" :visible.sync="drawer" :direction="'ttb'" :size="'100%'">
			<template #title>
				<div class="menu_logo" @click="goToHome">
					<img :src="require('@/assets/images/logo.png')" />
				</div>
			</template>
			<MenuList @closeDrawer="closeDrawer" @goToRequestDemo="goToRequestDemo"></MenuList>
		</el-drawer>

		<newForm ref="requestDemoRef"></newForm>
	</article>
</template>

<script>
import $http from "@/request/http";
import Menu from "./menu.vue"
import MenuList from "./menuList.vue";
import homeBg from '@/assets/images/homebg.png'
import newForm from "../views/requestDemo/newForm.vue";
import daohangImage from "@/assets/images/daohang.png"
import daohangBlackImage from "@/assets/images/daohang_black.png"

export default {
	name: "app-header",
	components: {
		Menu,
		MenuList,
		newForm
	},
	data() {
		return {
			//是否登录
			isLogin: this.$store.getters.getIsLogin,
			userInfo: this.$store.getters.getTokenInfo,
			routerR: true,
			drawer: false,
			currentPath: "/",
			daohangImageUrl: daohangImage
		};
	},
	watch: {
		//监听登录状态
		"$store.getters.getIsLogin": {
			handler(isLogin) {
				this.isLogin = isLogin
			},
			immediate: true,
		},
		'$route.path': {
			handler(newValue, oldValue) {
				console.log(newValue, oldValue);
				
				if (newValue) {
					this.updateHeaderBackground(newValue);
					this.handleScroll(newValue)
				}
			},
		}
	},
	created() {

	},

	mounted() {
		window.addEventListener('scroll', () => {
			this.handleScroll();
		});
		this.handleScroll(this.currentPath)
		// this.updateHeaderBackground(this.$route.path);
	},


	methods: {

		goToHome() {
			this.closeDrawer()
			this.$router.push('/home');
		},
		closeDrawer() {
			this.drawer = false
		},
		// goToLogin() {
		// 	// this.$router.push('/login');
		// 	console.log(this);

		// }

		goToRequestDemo() {
			this.$refs.requestDemoRef.openDialog()
		},

		// //如果当前页是首页，则正常展示，反之将背景图删去更新头部背景颜色
		updateHeaderBackground(newValue) {
			const headerElement = document.querySelector('.all-header');
			const headerBg = document.querySelector('.header-bg');
			const menuText = document.querySelector('.menu-bottom-text');

			this.$nextTick(() => {
				if (newValue === '/home' || newValue === '/') {
					headerElement.style.backgroundColor = 'transparent';
					headerBg.style.backgroundImage = "url(" + homeBg + ")";
					headerBg.style.minHeight = '600px';
					menuText.style.display = 'block';
					this.daohangImageUrl = daohangImage
				} else {
					headerElement.style.backgroundColor = '#fff';
					headerBg.style.backgroundImage = 'none';
					headerBg.style.minHeight = 'unset';
					menuText.style.display = 'none';
					this.daohangImageUrl = daohangBlackImage
				}
			})
		},

		handleScroll(newValue) {
			const currentPath = newValue || this.$route.path;
			const header = document.querySelector('.all-header');
			const menuWrap = document.getElementById('warp-menu')
			const isHome = currentPath === '/home' || currentPath === '/';
			if (window.scrollY < 100 && isHome) {
				menuWrap.classList.add('showFontWhite')

				this.daohangImageUrl = daohangImage
			}
			else {
				menuWrap.classList.remove('showFontWhite')
			}
			if (window.scrollY > 100) {
				header.style.backgroundColor = '#fff';
				header.style.position = 'fixed';
				header.style.top = '0';
				header.style.zIndex = '999';

				this.daohangImageUrl = daohangBlackImage
			} else {
				header.style.backgroundColor = 'transparent';
				header.style.position = 'static';
			}
		}
	}
};
</script>

<style>
body>.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
	background-color: #1da6b8;
	color: #fff !important;
}
</style>
<style lang="scss">
.mh111 {
	.layui-fluid {
		padding: 0;

		.layui-row {
			display: flex;
			justify-content: space-between;

			&::after {
				display: none;
			}

			&::before {
				display: none;
			}
		}
	}
}

.header-bg {
	min-height: 600px;
	background-image: url('../assets/images/homebg.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center
}


.all-header {
	width: 100%;
	padding: 10px 0;
}

.header-bg .logo_image {
	&:hover {
		cursor: pointer;
	}
}

.menu_btns {
	display: none;

	img {
		width: 30px;
	}
}

.menu_logo {
	img {
		width: 160px;
	}
}

.menu-bottom-text {
	padding: 100px 0;

	p {
		font-size: 53px;
		line-height: 55px;
		color: #fff;
		font-weight: bold;
	}

	.apply_btn {
		margin-top: 30px;
		background-color: #1da6b8;
		color: #fff;
		border: none;
		border-radius: 5px;
		line-height: 34px;
		font-size: 24px;
		font-weight: bold;
	}
}

@media (max-width: 1200px) {
	#warp-menu {
		display: none;
	}

	.logo_image {
		img {
			width: 70%;
		}
	}

	.menu_btns {
		display: block;
	}

	.logo_sdf {
		display: flex;
		justify-content: space-between;
	}

	.page_tips {
		font-size: 12px;
	}

	.header-bg {
		background-size: cover;
	}

	.menu-bottom-text {
		padding: 100px 20px;
	}
}
</style>
<!-- 显示字体为白色 -->
<style lang="scss" scoped>
::v-deep #warp-menu.showFontWhite>.el-menu {
	background-color: transparent !important;
}

::v-deep #warp-menu.showFontWhite>.el-menu.el-menu--horizontal {
	border: none;
}

::v-deep #warp-menu.showFontWhite>.el-menu--horizontal>.el-menu-item {
	padding: 0 !important;
	color: #fff;
	margin: 0 20px !important;
}

::v-deep #warp-menu.showFontWhite>.el-menu--horizontal .el-menu-item:hover {
	color: #fff;
}

::v-deep #warp-menu.showFontWhite>.el-menu--horizontal>.el-menu-item:focus,
::v-deep #warp-menu.showFontWhite>.el-menu--horizontal>.el-menu-item:hover {
	background-color: transparent !important;
}

// 子菜单标题
::v-deep #warp-menu.showFontWhite>.el-menu>.el-submenu>.el-submenu__title {
	color: #fff;
}

::v-deep #warp-menu.showFontWhite>.el-menu>.el-submenu>.el-submenu__title:hover {
	background-color: transparent !important;
}

// 二级菜单箭头颜色
::v-deep #warp-menu.showFontWhite>.el-menu>.el-submenu>.el-submenu__title i {
	color: #fff;
}
</style>